import { parseJSON } from "date-fns";
import { ISerializes, IDeserializes } from "./serializable";
import { JSONEntries } from "./json";

export interface IUser extends ISerializes<IUserExport>, IDeserializes<IUserImport> {
  userId: string;
  firstName: string;
  lastName: string;
  name: string;
  emailAddress: string;
  createdOn: Date;
  updatedOn: Date | null;
}
export interface IUserImport {
  userId: string;
  firstName: string;
  lastName: string;
  emailAddress: string;
  createdOn: string;
  updatedOn: string | null;
}
export interface IUserExport {
  userId: string;
  firstName: string;
  lastName: string;
  emailAddress: string;
}

export class User implements IUser {
  public userId: string = null;
  public firstName = "";
  public lastName = "";
  public emailAddress: string = null;
  public createdOn: Date | null;
  public updatedOn: Date | null;

  get name(): string {
    const names = [this.firstName, this.lastName].filter(name => !!name);
    return names.join(" ");
  }

  constructor(json: Partial<IUserImport> = {}) {
    this.deserialize(json);
  }

  /**
   * Deserialize JSON into the class
   *
   * @param json Properties to add to the entity
   */
  public deserialize(json: Partial<IUserImport> = {}): void {
    Object.entries(json).forEach(([key, value]: JSONEntries) => {
      if ((key === "createdOn" || key === "updatedOn")) {
        if (typeof value === "string") {
          this[key] = parseJSON(value) as Date;
        }
      } else {
        this[key] = value;
      }
    });
  }

  /**
   * Serialize for calling API resources
   */
  public toJSON(): IUserExport {
    return {
      userId: this.userId,
      firstName: this.firstName,
      lastName: this.lastName,
      emailAddress: this.emailAddress
    };
  }
}
